(function(){
  window.__piCartVer='modal-v17';
  if (window.PI_STICKY_ATC_OFF === undefined) window.PI_STICKY_ATC_OFF = true;
  if (window.PI_ROUND_BTNS === undefined) window.PI_ROUND_BTNS = true;
  var KLAVIYO_COMPANY='WXYSVP';
  if (window.PI_KLAVIYO_FORM_ID === undefined) window.PI_KLAVIYO_FORM_ID = 'TXTY9F';
  /* product handle -> restock note. Set value to '' or remove to clear once restocked. */
  if (window.PI_RESTOCK === undefined) window.PI_RESTOCK = {'buckle-bag-noir':'Restock July 10th','buckle-bag-noir-copy':'Restock July 10th'};

  function loadKlaviyo(){
    window._klOnsite = window._klOnsite || [];
    if (window.klaviyo || document.querySelector('script[src*="static.klaviyo.com"]')) return;
    var s=document.createElement('script');
    s.async=true; s.type='text/javascript';
    s.src='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id='+KLAVIYO_COMPANY;
    (document.head||document.documentElement).appendChild(s);
  }
  loadKlaviyo();

  function openKlaviyo(){
    var id = window.PI_KLAVIYO_FORM_ID; if(!id) return false;
    var n=0;
    (function go(){
      if (window.klaviyo && typeof window.klaviyo.openForm==='function'){ try{ window.klaviyo.openForm(id); }catch(e){} return; }
      window._klOnsite = window._klOnsite || [];
      if (n===0) window._klOnsite.push(['openForm', id]);
      if (n++ < 30) setTimeout(go, 250);
    })();
    return true;
  }
  function installPromoRewire(){
    if (window.__piPromoKlaviyo) return;
    window.__piPromoKlaviyo = true;
    document.addEventListener('click', function(e){
      var t=e.target;
      if (!t || !t.closest) return;
      if (t.closest('.pi-promo__x')) return;
      var hit = t.closest('.pi-promo__btn, .pi-promo, .pi-subscribe-offer, #pi-subscribe-offer');
      if (!hit) return;
      if (window.PI_KLAVIYO_FORM_ID){ e.preventDefault(); e.stopImmediatePropagation(); openKlaviyo(); }
    }, true);
  }

  function installMenuFix(){
    if (window.__piMenuFix) return;
    var details = document.querySelector('header-drawer details, .menu-drawer-container details');
    if (!details) return;
    window.__piMenuFix = true;
    function upd(){
      var open = details.hasAttribute('open');
      document.querySelectorAll('#pi-hero-ov').forEach(function(h){
        h.style.setProperty('visibility', open?'hidden':'visible','important');
        h.style.setProperty('opacity', open?'0':'1','important');
      });
    }
    try{ new MutationObserver(upd).observe(details, {attributes:true, attributeFilter:['open']}); }catch(e){}
    details.addEventListener('toggle', upd);
    upd();
  }

  /* ---- Restock badge: replace SOLD OUT with a restock note on listed products (cards + PDP) ---- */
  function restockBadge(){
    var R = window.PI_RESTOCK || {};
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function(c){
      var a=c.querySelector('a[href*="/products/"]'); if(!a) return;
      var h=a.getAttribute('href').split('/products/')[1].split('?')[0].split('/')[0];
      if(!R[h]) return;
      c.querySelectorAll('.card__badge').forEach(function(b){ b.style.setProperty('display','none','important'); });
      var media=c.querySelector('.card__media')||c.querySelector('.card__inner')||c;
      if(media && !media.querySelector('.pi-restock-badge')){
        if(getComputedStyle(media).position==='static') media.style.position='relative';
        var s=document.createElement('span'); s.className='pi-restock-badge'; s.textContent=R[h]; media.appendChild(s);
      }
    });
    if(/\/products\//.test(location.pathname)){
      var ph=location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
      if(R[ph]){
        var host=document.querySelector('.product__media-wrapper');
        if(host){
          host.querySelectorAll('.card__badge').forEach(function(b){ b.style.setProperty('display','none','important'); });
          if(!host.querySelector('.pi-restock-badge')){
            if(getComputedStyle(host).position==='static') host.style.position='relative';
            var s2=document.createElement('span'); s2.className='pi-restock-badge'; s2.textContent=R[ph]; host.appendChild(s2);
          }
        }
      }
    }
  }

  function piSetShipNote(){
    var note = document.querySelector('.pi-ship-note');
    if (!note) return;
    var isLeather = (window.__piShipTags||[]).indexOf('leather') > -1;
    var txt = isLeather
      ? 'Made to Order. Free Shipping Globally. Duties & Tariffs Paid For. Ships in 1–2 weeks.'
      : 'Free Shipping Globally. Duties & Tariffs Paid For.';
    if (note.textContent !== txt) note.textContent = txt;
  }
  function shipNote(){
    if (!/\/products\//.test(location.pathname)) return;
    if (!document.querySelector('.pi-ship-note')) return;
    var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    if (window.__piShipHandle !== handle){
      if (window.__piShipFetching) return;
      window.__piShipFetching = true;
      window.__piShipHandle = handle;
      window.__piShipTags = undefined;
      fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
        window.__piShipTags = (p.tags||[]).map(function(t){return String(t).toLowerCase();});
      }).catch(function(){ window.__piShipTags=[]; }).then(function(){ window.__piShipFetching=false; piSetShipNote(); });
      return;
    }
    if (window.__piShipTags !== undefined) piSetShipNote();
  }

  if (!document.getElementById('pi-cart-style')){
    var st=document.createElement('style'); st.id='pi-cart-style';
    st.textContent =
'.pi-ship-note{-webkit-text-stroke:0.5px currentColor!important;margin:20px 0!important;}'+      '.pi-reward{padding:2px 0 0;}'+
      '.pi-reward__label{font-size:12px;letter-spacing:0.03em;color:#111;margin-bottom:9px;}'+
      '.pi-reward__label b{font-weight:600;}'+
      '.pi-reward__track{height:4px;background:#e7e3db;border-radius:999px;overflow:hidden;}'+
      '.pi-reward__fill{height:100%;background:#111;border-radius:999px;transition:width .4s ease;}'+
      'cart-drawer .drawer__inner{position:fixed!important;top:50%!important;left:50%!important;right:auto!important;bottom:auto!important;width:min(94vw,560px)!important;max-width:560px!important;height:auto!important;max-height:88vh!important;border-radius:16px!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;transition:opacity .28s ease,transform .28s ease,visibility .28s;box-shadow:0 30px 80px rgba(0,0,0,.22);}'+
      'cart-drawer .drawer__header{order:1;flex:0 0 auto;}'+
      'cart-drawer #comp-ship-line{order:2;flex:0 0 auto;}'+
      'cart-drawer cart-drawer-items{order:3;flex:1 1 auto;overflow-y:auto;min-height:0;}'+
      'cart-drawer .drawer__footer{order:4;flex:0 0 auto;}'+
      '.header__icon--cart{color:#1a1a1a!important;opacity:1!important;visibility:visible!important;font-size:0!important;}'+
      '.header__icon--cart .pi-bag{display:block!important;stroke:#1a1a1a!important;flex:0 0 auto!important;width:20px!important;height:20px!important;min-width:20px!important;}'+
      '.header__icon--cart .cart-count-bubble{font-size:10px!important;}';
    document.head.appendChild(st);
  }

  function installCardNav(){
    if (window.__piCardNavCapture) return;
    window.__piCardNavCapture = true;
    document.addEventListener('click', function(e){
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('.card-wrapper, .product-card-wrapper');
      if (!card) return;
      if (t.closest('.pi-card-bag, button, [name="add"], input, label, select, [class*="swiper-button"], [class*="pagination"], .pi-feed__add, .quick-add__submit')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = href;
    }, true);
  }

  function roundBtns(){
    if (!window.PI_ROUND_BTNS) return;
    document.querySelectorAll('.product-form__submit, .product-form__buttons button[name="add"], button.product-form__submit').forEach(function(b){
      b.style.setProperty('border-radius','999px','important');
      b.style.setProperty('overflow','hidden','important');
    });
    document.querySelectorAll('shop-pay-wallet-button, [is="shop-pay-wallet-button"]').forEach(function(b){
      b.style.setProperty('border-radius','999px','important');
      b.style.setProperty('overflow','hidden','important');
      b.style.setProperty('display','block','important');
    });
  }

  function stickyAtcToggle(){
    if (window.PI_STICKY_ATC_OFF){
      document.querySelectorAll('.pi-sticky-atc').forEach(function(b){ b.style.setProperty('display','none','important'); });
      document.body.classList.remove('pi-atc-on');
      document.body.style.setProperty('padding-bottom','0','important');
    }
  }

  function cartIcon(){
    document.querySelectorAll('.header__icon--cart').forEach(function(a){
      if (a.querySelector('svg') || a.querySelector('.pi-bag')) return;
      a.insertAdjacentHTML('afterbegin', '<svg class="pi-bag" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#1a1a1a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7L6 8z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg>');
    });
  }

  function centerDrawer(){
    document.querySelectorAll('cart-drawer').forEach(function(cd){
      var inner=cd.querySelector('.drawer__inner'); if(!inner) return;
      var active=cd.classList.contains('active');
      inner.style.setProperty('transform', active?'translate(-50%,-50%)':'translate(-50%,-46%)','important');
      inner.style.setProperty('opacity', active?'1':'0','important');
      inner.style.setProperty('visibility', active?'visible':'hidden','important');
      if(!cd.__piClassObs){ cd.__piClassObs=true; new MutationObserver(function(){ centerDrawer(); }).observe(cd,{attributes:true,attributeFilter:['class']}); }
    });
  }

  function money(c){ var n=c/100; return '$'+(n%1?n.toFixed(2):n.toFixed(0)); }
  function rewardBar(){
    document.querySelectorAll('#comp-ship-line').forEach(function(c){
      var threshold=parseInt(c.getAttribute('data-threshold')||'0',10);
      var total=parseInt(c.getAttribute('data-total')||'0',10);
      if(!threshold) return;
      var remaining=threshold-total;
      var pct=Math.max(4, Math.min(100, Math.round(total/threshold*100)));
      var bar=c.querySelector(':scope > .pi-reward');
      if(!bar){ bar=document.createElement('div'); bar.className='pi-reward'; bar.innerHTML='<div class="pi-reward__label"></div><div class="pi-reward__track"><div class="pi-reward__fill"></div></div>'; c.appendChild(bar); }
      bar.querySelector('.pi-reward__label').innerHTML = remaining>0 ? ('<b>'+money(remaining)+'</b> away from free shipping') : 'Your order qualifies for free shipping';
      bar.querySelector('.pi-reward__fill').style.width = (remaining>0?pct:100) + '%';
    });
  }

  function setBtn(b, label, primary){
    var I = function(p, v){ b.style.setProperty(p, v, 'important'); };
    I('height','56px'); I('min-height','56px'); I('max-height','56px');
    I('display','flex'); I('align-items','center'); I('justify-content','center');
    I('padding','0 18px'); I('line-height','1'); I('width','100%'); I('box-sizing','border-box');
    if (primary){ I('background','#111'); I('border','1px solid #111'); } else { I('background','#fff'); I('border','1px solid #ddd9d1'); I('box-shadow','none'); }
    var span = b.querySelector(':scope > .pi-btn-label');
    if (!span){
      Array.prototype.slice.call(b.childNodes).forEach(function(n){ if(n.nodeType===3) n.textContent=''; });
      Array.prototype.forEach.call(b.children, function(c){ c.style.setProperty('display','none','important'); });
      span = document.createElement('span'); span.className='pi-btn-label'; b.appendChild(span);
    } else { Array.prototype.forEach.call(b.children, function(c){ if(c!==span) c.style.setProperty('display','none','important'); }); }
    if (span.textContent !== label) span.textContent = label;
    span.style.cssText = 'display:inline-block;font-size:12px;letter-spacing:0.16em;text-transform:uppercase;line-height:1;color:'+(primary?'#fff':'#111')+';';
  }
  function fixButtons(){
    document.querySelectorAll('.onward-opt-out-link').forEach(function(b){ setBtn(b, 'Checkout', true); });
    document.querySelectorAll('#main-cart-footer .cart__ctas, cart-drawer .cart__ctas, .drawer__footer .cart__ctas').forEach(function(ctas){
      var done=false;
      ctas.querySelectorAll('.onward-checkout-btn').forEach(function(b){
        if (b.classList.contains('onward-opt-out-link')) return;
        if (!done){ setBtn(b, 'Checkout+', false); done=true; } else { b.style.setProperty('display','none','important'); }
      });
    });
  }

  function apply(){ cartIcon(); centerDrawer(); rewardBar(); fixButtons(); stickyAtcToggle(); roundBtns(); shipNote(); installMenuFix(); restockBadge(); }
  function start(){
    installPromoRewire();
    installCardNav();
    apply();
    var scheduled=false, mo;
    function schedule(){ if(scheduled) return; scheduled=true; requestAnimationFrame(function(){ scheduled=false; mo.disconnect(); try{ apply(); } finally { mo.observe(document.body,{childList:true,subtree:true}); } }); }
    mo = new MutationObserver(schedule);
    mo.observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
